import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';


function* fetchUserAccess(action: actionsInterfaces.IFetchUserAccessAction) {
  let token: string;
  try {    
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userAccess`    
    if(action.query)callUrl=`${host}userAccess${action.query}`

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userAccess.setUserAccesses(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}


function* fetchSearch(action: actionsInterfaces.IFetchUserAccessAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userAccess`    
    if(action.query)callUrl=`${host}userAccess${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userAccess.setSearchUserAccess(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}


function* getUserAccessByEmail(action: actionsInterfaces.IGetUserAccessByEmailAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<actionsInterfaces.IUserAccess[]> = yield axios.get(
      `${host}userAccess?filter=c.user.email=%27${encodeURIComponent(action.email)}%27`,
      { headers: { Authorization: token },
    });
    if (action.callback) action.callback(response.data[0] ?? null);
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) action.callback(undefined, e);
  }
}

function* postUserAccess(action: actionsInterfaces.IPostUserAccessAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<actionsInterfaces.IUserAccess> = yield axios.post(
      `${host}userAccess`,
      action.userAccess,
      { headers: { Authorization: token },
    });
    yield put(actions.userAccess.addSuccess(response.data));
    if (action.callback) action.callback(response.data);
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) action.callback(undefined, e);
  }
}

function* putUserAccess(action: actionsInterfaces.IPutUserAccessAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<actionsInterfaces.IUserAccess> = yield axios.put(
      `${host}userAccess`,
      action.userAccess,
      { headers: { Authorization: token },
    });
    yield put(actions.userAccess.putSuccess(response.data));
    if (action.callback) action.callback(response.data);
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) action.callback(undefined, e);
  }
}



function* deleteUserAccess(action: actionsInterfaces.IDeleteUserAccessAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let queryparams = `${action.item.id}?email=${action.item.updatedBy.email}&name=${action.item.updatedBy.name}`    
    const response: AxiosResponse<any> = yield axios.delete(`${host}userAccess/${queryparams}`,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userAccess.deleteUserAccessSuccess());
      if (action.callback) { action.callback(response); }        
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.FETCH_USERACCESS, fetchUserAccess),
    takeLatest(actionsTypes.GET_USERACCESS_BY_EMAIL, getUserAccessByEmail),
    takeLatest(actionsTypes.ADD_USERACCESS, postUserAccess),
    takeLatest(actionsTypes.UPDATE_USERACCESS, putUserAccess),
    takeLatest(actionsTypes.DELETE_USERACCESS, deleteUserAccess),
    takeLatest(actionsTypes.FETCH_SEARCH_USERACCESS, fetchSearch),
  ])
}

